<template>
  <div class="product-card">
    <div class="product-thumbnail-wrapper product-thumbnail-height">
      <div class="product-thumbnail-container">
        <div class="product-thumbnail-container link-enabled vertical-alignment">
          <div class="product-image">
            <picture>
              <source v-if="canUseAvif" type="image/avif" :srcset="imageSrcAvif" />
              <source type="image/webp" :srcset="imageSrcWebp" />
              <img
                :src="imageSrcAvif"
                alt="Dream wedding"
                :width="imageWidth"
                :height="imageWidth / imageAspectRatio"
                fetchpriority="auto"
                decoding="auto"
                loading="eager"
                @error="onSourceError"
              />
            </picture>
          </div>
          <div class="product-description">
            <div class="medium">
              {{ productItem?.detail?.brand?.name }}
            </div>
          </div>
        </div>
        <div class="dream-fund-description medium">
          {{ productItem?.detail?.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { dreamFundProductCard } from 'config';
import { useEnvPropsStore } from '~/stores/envProps';

const canUseAvif = ref(true);
const envPropsStore = useEnvPropsStore();
const cdnUrl = envPropsStore.envProps?.cdnUrl || '';
const imageSrcAvif = `${cdnUrl}/img/${dreamFundProductCard.dreamFundThumbnailImg}.avif`;
const imageSrcWebp = `${cdnUrl}/img/${dreamFundProductCard.dreamFundThumbnailImg}.webp`;

defineProps({
  productItem: {
    type: Object,
    required: true,
  },
  imageAspectRatio: {
    type: Number,
    default: 0.8,
  },
  imageWidth: {
    type: Number,
    default: 130,
  },
});

useHead(() => ({
  link: [
    {
      rel: 'preload',
      as: 'image',
      type: 'image/avif',
      href: imageSrcAvif,
      fetchpriority: 'high',
    },
    {
      rel: 'preload',
      as: 'image',
      type: 'image/webp',
      href: imageSrcWebp,
      fetchpriority: 'high',
    },
  ],
}));

const onSourceError = () => {
  canUseAvif.value = false;
};
</script>

<style lang="scss" scoped>
.vertical-alignment {
  display: flex;
  flex-direction: column;
}
.product-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.product-image {
  order: 1;
}
.product-description {
  margin-top: rem-calc(29);
  order: 2;
}
.dream-fund-description {
  margin-top: rem-calc(32);
  height: 100%;
}
.product-thumbnail-height {
  height: 100%;
}

@media print {
  .product-card {
    page-break-inside: avoid;
    margin-top: rem-calc(24);
  }
}
</style>
